import EmailTable from './EmailTable';
import ShimmerTable from './ShimmerTable';
import {
  MakeGoodSuggestionResponse,
  PreEmptedSpot,
  PreEmptedSpotDetails,
} from './types';

const MakeGoodRecommendation = ({
  data,
  isLoading,
  createOffer,
  preEmptedSpotDetails,
}: {
  data: any;
  isLoading: boolean;
  createOffer?: (record: any) => void;
  preEmptedSpotDetails?: PreEmptedSpotDetails;
}) => (
  <>
    <span className="font-semibold text-[14px] text-navy-black font-sans">
      Choose a makegood recommendation from following, listed in order of best match first
    </span>
    {isLoading ? (
      <ShimmerTable arraySize={3} />
    ) : (
      <EmailTable
        data={data}
        showCreateOfferButton={true}
        createOffer={createOffer}
        preEmptedSpotDetails={preEmptedSpotDetails}
      />
    )}
  </>
);

export default MakeGoodRecommendation;